import { render, staticRenderFns } from "./PayinTransDetails.vue?vue&type=template&id=488c36c0&scoped=true"
import script from "./PayinTransDetails.vue?vue&type=script&lang=js"
export * from "./PayinTransDetails.vue?vue&type=script&lang=js"
import style0 from "./PayinTransDetails.vue?vue&type=style&index=0&id=488c36c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488c36c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('488c36c0')) {
      api.createRecord('488c36c0', component.options)
    } else {
      api.reload('488c36c0', component.options)
    }
    module.hot.accept("./PayinTransDetails.vue?vue&type=template&id=488c36c0&scoped=true", function () {
      api.rerender('488c36c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/PayinTransDetails.vue"
export default component.exports